import ApiService from '../../api/api';

const _ = require('lodash');

export default {
    namespaced: true,
    state() {
        return {
            formAuth: {
                name: '',
                password: '',
                login: '',
                email: null,
                phone: null,
                password_confirmation: '',
               // remember: false,
                checked: true,
            },
            user: window.laravel.user,
        }
    },
    getters: {
        isAuth: (state) => Object(state.user).hasOwnProperty('email'),
        userId: (state) => Object(state.user).hasOwnProperty('email') && Number(state.user.id),
        hasPhone: (state) => Object(state.user).hasOwnProperty('phone') && state.user.phone !== null,
        phone: (state) => state.user.phone,
    },
    mutations: {
        setPhone(state, phone) {
            state.user.phone = phone;
        },
        generatePassword(state) {
            state.formAuth.password = Math.random().toString(36).slice(-8);
            state.formAuth.password_confirmation = state.formAuth.password;
        },
        clearData(state){
            state.formAuth.name = '';
            state.formAuth.password = '';
            state.formAuth.login = '';
            state.formAuth.phone = null;
            state.formAuth.email = null;
            state.formAuth.password_confirmation = '';
           // state.formAuth.remember = false;
           //  state.formAuth.checked = false;
        },
        setUser(state, user){
            state.user = user;
        },
        loadFormAuth(state) {
            let formAuth = _.cloneDeep(state.formAuth);

            Object.keys(state.formAuth)
              .forEach(property => {
                  if (typeof state.user[property] !== "undefined") {
                      formAuth[property] = state.user[property];
                  }
              });

            state.formAuth = formAuth;
        }
    },
    actions: {
        csrfCookie({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/csrf-cookie')
                    .then((response) => {
                        resolve(response);
                    }).catch(error => {

                });
            });
        },
        register({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/csrf-cookie').then((response) => {
                    ApiService.post('/register', state.formAuth)
                        .then((response) => {
                            resolve(response);
                        })
                        .catch((error) => {
                            error.cookie = document.cookie;

                            ApiService.post('/log-auth/error', error);
                            reject(error);
                        });
                });
            });
        },
        login({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                state.formAuth.cookie = document.cookie;

                ApiService.post('/log-auth/auth', state.formAuth);

                ApiService.get('/csrf-cookie').then((response) => {
                    response.cookie = document.cookie;

                    ApiService.post('/log-auth/csrf', response);

                    ApiService.post('/login', state.formAuth)
                        .then((response) => {
                            resolve(response);
                        })
                        .catch((error) => {
                            error.cookie = document.cookie;

                            ApiService.post('/log-auth/error', error);
                            reject(error);
                        });
                });
            });
        },
        emailReset({state, commit, getters}, email){
            return new Promise((resolve, reject) => {
                ApiService.get('/csrf-cookie').then(response => {
                    ApiService.post('/password/email',  email)
                        .then((response) => {
                            resolve(response);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                });
            });
        },
        resetPassword({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.get('/csrf-cookie').then(response => {
                    ApiService.post('/password/reset', form)
                        .then((response) => {
                            resolve(response);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                });
            });
        },
    }
};
